module.exports = __webpack_public_path__ + "static/media/data.a0297641.png";